import { render, staticRenderFns } from "./ResizableImageTemplate.vue?vue&type=template&id=13f227d0&scoped=true"
import script from "./ResizableImageTemplate.vue?vue&type=script&lang=js"
export * from "./ResizableImageTemplate.vue?vue&type=script&lang=js"
import style0 from "./ResizableImageTemplate.vue?vue&type=style&index=0&id=13f227d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f227d0",
  null
  
)

export default component.exports